<template>
    <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body>
    <div slot="title" class="dialog-title">
        <p>{{ softwareName+'考核情况' }}</p>
        <p class="grey">(总分</p>
        <p class="number">{{ fullScore }}</p>
        <p class="grey">分   步骤总得分</p>
        <p class="number">{{ stepFullScore }}</p>
        <p class="grey">分)</p>
    </div>
    <div class="content-box">
        <div class="thead">
            <div>考核步骤</div>
            <div>考核任务</div>
            <div>步骤得分</div>
        </div>
        <div class="tbody">
            <div v-for="(item,index) in tableData" class="tbody-item" :key="index">
                <p class="left-body overflow">{{ item.name }}</p>
                <div class="children-box">
                    <div v-for="(el,i) in item.children" class="child-box" :key="i">
                        <p class="overflow">{{el.name}}</p>
                        <p>{{ el.score }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </el-dialog>
</template>

<script>
    export default {
        data(){
            return {
                /**总分 */
                fullScore:0,
                /**步骤总得分 */
                stepFullScore:0,
                dialogVisible:false,
                tableData:[],
                softwareName:''
            }
        },
        methods:{
            
        },
        computed:{
        }
    }
</script>

<style lang="less" scoped>
/deep/.el-dialog__title{
    font-size: 16px;
    font-weight: 700;
}
.thead{
    height: 4.8rem;
    background-color: #ECF3FF;
    display: flex;
    align-items: center;
    color: #334681;
    font-weight: 700;
    padding: 0 3.5rem;
    border: 1px solid #e8ecef;
    &> :nth-child(n){
        flex: 1;
        text-align: center;
    }
}
.tbody-item{
    display: flex;
    color: #334681;
}
.single{
    background-color: rgba(236,243,255,0.20);
}
.twin{
    background-color: #ECF3FF;
}
/deep/.el-dialog__body{
    padding:0 3rem 5rem 3rem;
}
/deep/.el-dialog__header{
    padding: 3rem 5rem;
}
/deep/.el-dialog{
    border-radius: 16px;
}
/deep/.el-dialog__headerbtn{
    top: 1rem;
    right: 14px;
    color: #8590B3;
}
.content-box{
    height: 50rem;
    overflow: auto;
}
.tbody-item{
    display: flex;
    .left-body{
        border: 1px solid #e8ecef;
        border-top: none;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 4.7rem;
    }
    .children-box{
        // border: 1px solid #e8ecef;
        flex: 2;
        .child-box{
            height: 4.7rem;
            display: flex;
            &> :nth-child(n){
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                border-right: 1px solid #e8ecef;
                border-bottom: 1px solid #e8ecef;
            }
        }
    }
}
/deep/.v-modal{
    z-index: 900 !important;
}
.dialog-title{
    display: flex;
    color: #334681;
    &> :nth-child(1){
        font-size: 16px;
        font-weight: 700;
    }
}
.grey{
    color: #8590B3;
    font-size: 16px;
}
.number{
    font-size: 16px;
}

</style>